import { supabase } from './supabase.js';

/** Resumen almacenado en Supabase (sin data URLs enormes en imagen) */
export function buildComunidadItemSnapshot(ev) {
  const img = ev.imagenUrl;
  const safeImg = typeof img === 'string' && img.length > 0 && !img.startsWith('data:') ? img : null;
  return {
    id: ev.id,
    title: ev.title,
    place: ev.place,
    date: ev.date,
    price: ev.price,
    tag: ev.tag,
    type: ev.type,
    extraTipo: ev.extraTipo || null,
    color: ev.color,
    imagenUrl: safeImg,
    mapsUrl: ev.mapsUrl || null,
    entrada_tipo: ev.entrada_tipo ?? null,
    musicGenres: Array.isArray(ev.musicGenres) ? ev.musicGenres : [],
  };
}

export async function loadComunidadGuardadosSet(userId) {
  if (!userId) return new Set();
  const { data, error } = await supabase
    .from('comunidad_guardados')
    .select('item_id')
    .eq('user_id', userId);
  if (error) return new Set();
  return new Set((data || []).map(r => String(r.item_id)));
}

export async function listComunidadGuardados(userId) {
  if (!userId) return [];
  const { data, error } = await supabase
    .from('comunidad_guardados')
    .select('id, item_id, item_snapshot, created_at')
    .eq('user_id', userId)
    .order('created_at', { ascending: false });
  if (error) return [];
  return data || [];
}

export async function insertComunidadGuardado(userId, ev) {
  return supabase
    .from('comunidad_guardados')
    .upsert(
      {
        user_id: userId,
        item_id: String(ev.id),
        item_snapshot: buildComunidadItemSnapshot(ev),
      },
      { onConflict: 'user_id,item_id' }
    );
}

export async function deleteComunidadGuardado(userId, itemIdStr) {
  return supabase
    .from('comunidad_guardados')
    .delete()
    .eq('user_id', userId)
    .eq('item_id', String(itemIdStr));
}
